/**
 * Created by FengqiZhang on 7/4/17.
 */
import $ from 'jquery';
import Parallax from 'parallax-scroll';

export class ParallaxScroll {
  public static selector: string;

  public static frontend(el: HTMLElement, opt: any) {
    const $el = $(el);
    if ($el.attr('id').trim() !== '') {
      ParallaxScroll.selector = `#${$el.attr('id')} > .underlay`;
      if ($(ParallaxScroll.selector).length === 0) {
        $(el).prepend($('<div class="underlay"></div>'));
      }
      const style = window.getComputedStyle(
        document.querySelector(ParallaxScroll.selector),
      );
      if (style.getPropertyValue('min-height') === '0.1px') {
        return new this($el);
      }
    }
  }

  constructor(public $elem: JQuery, public updateHook?) {
    const parallax = new Parallax(ParallaxScroll.selector, {speed: 0.3});
    parallax.animate();
  }
}
